import React from "react";
import Icon1 from '../../images/svg-4.svg'
import Icon2 from '../../images/svg-5.svg'
import Icon3 from '../../images/svg-6.svg'
import {
  ServicesContainer,
  ServicesH1,
  ServicesWrapper,
  ServicesCard,
  ServicesIcon,
  ServicesH2,
  ServicesP,
  ServicesCardLink,
} from "./ServicesElements";

const Services = () => {
  return (
    <ServicesContainer id="services">
      <ServicesH1>Our Services</ServicesH1>
      <ServicesWrapper>
        <ServicesCardLink to="/finance">
        <ServicesCard>
          <ServicesIcon src={Icon1} />
          <ServicesH2>Finance</ServicesH2>
          <ServicesP>
            Lead your business with every meaningful metric in the palm of your
            hand.
          </ServicesP>
        </ServicesCard>
        </ServicesCardLink>
        <ServicesCard>
          <ServicesIcon src={Icon2} />
          <ServicesH2>Retail & ECommerce</ServicesH2>
          <ServicesP>
            Keep the finger on your organization's financial pulse.
          </ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon3} />
          <ServicesH2>BI </ServicesH2>
          <ServicesP>
            Become the information hero you were hired to be and think strategically.
          </ServicesP>
        </ServicesCard>
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
